import React, {useMemo} from "react";
import {useEditor} from "@smartfire/wordpress-react";
import style from "./style.module.scss";
import dayjs from "dayjs";
import { useTranslation } from 'react-i18next';

function Tuile({category, image, title, date, link, position, picto}){
    const {isEditing} = useEditor();
    const {t} = useTranslation();

    const dateFormat = useMemo(() => {
        return dayjs(date).format("ll")
    }, [date])

    return <a className={`${style.tuile} ${style[position]}`} href={!isEditing && link}>
        <div className={style.thumbnail}>
            <img className={style.image} src={image} alt={""} />
        </div>
        <div className={style.content}>
            <img className={style.picto} src={picto} alt={""} />
            <div className={style.category} dangerouslySetInnerHTML={{__html:category}}/>
            {date && <div className={style.date}>{dateFormat}</div>}
            <div className={style.text} dangerouslySetInnerHTML={{__html:title}} />
        </div>
        <div className={style.seeMore}>{t('Lire la suite')}</div>
    </a>
}

export default Tuile;

